import { Component, Input, OnInit } from '@angular/core';
import { ICompositeNode, INode } from '@feature/nodes/models/node-type';
import { RelatedContactView } from '../../models/related-contacts-types'

@Component({
  selector: 'mojo-related-contact-item',
  templateUrl: './related-contact-item.component.html'
})
export class RelatedContactItemComponent implements OnInit {

  @Input() children: INode[];
  fullView = false;


  constructor() { }

  getItems(): INode[] {
    if (this.children != undefined) {
      const style = this.fullView ? 1 : 0;
      const item = this.children.filter(x => x.Name == 'RelatedContactView' && (x as ICompositeNode<RelatedContactView>).Props.Style == style);
      return item;
    }
    return [];
  }

  toggle() {
    this.fullView = !this.fullView;
  }

  ngOnInit(): void {
  }

}
